<template>
  <div class="Scrollbar">
    <slot></slot>
  </div>
</template>

<script>

export default {
  mounted () { this.activate (); },
  updated () { this.activate (); },

  methods: {
    activate () {
      let ems = this.$el.getElementsByTagName ('a');
      let ys = [];

      for (let em of ems) {
        let e = document.getElementById (em.href.split ('#') [1]);
        let bb = e.getBoundingClientRect ();
        ys.push (bb.y + window.scrollY);
      }

      let fn = () => {
        let cy = window.scrollY;

        let bestI = null;
        let bestD = Infinity;

        for (let i = 0; i < ems.length; i++) {
          let y = ys [i];
          let D = Math.abs (y - cy);

          if (D < bestD) {
            bestI = i;
            bestD = D;
          }
        }

        for (let i = 0; i < ems.length; i++) {
          if (i == bestI) {
            ems [i].classList.add ('active');
          } else {
            ems [i].classList.remove ('active');
          }
        }
      };

      window.removeEventListener ('scroll', fn);
      window.addEventListener ('scroll', fn);
    }
  }
}

</script>